"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACButton = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable react/react-in-jsx-scope */
var antd_1 = require("antd");
var react_1 = require("react");
var ripple_1 = require("../utils/ripple");
var XLSX = __importStar(require("xlsx"));
var ACButton = function (props) {
    var _a, _b, _c;
    var _d = (0, react_1.useState)(false), disabled = _d[0], setDisabled = _d[1];
    (0, react_1.useEffect)(function () {
        // if (props.disabled) {
        setDisabled((props === null || props === void 0 ? void 0 : props.disabled) || false);
        // }
    }, [props.disabled]);
    // Function to handle Excel download
    var handleDownloadExcel = function () {
        try {
            var thead_1 = props.thead, tbody = props.tbody;
            if (!thead_1 || !Array.isArray(thead_1) || thead_1.length === 0) {
                console.error('ACButton: thead is required for Excel download');
                return;
            }
            // Create worksheet data with headers
            var worksheetData_1 = [];
            // Add header row
            worksheetData_1.push(thead_1);
            // Add data rows if tbody is provided
            if (tbody && Array.isArray(tbody) && tbody.length > 0) {
                tbody.forEach(function (row) {
                    var rowData = thead_1.map(function (header) {
                        return row[header] !== undefined && row[header] !== null ? row[header] : '';
                    });
                    worksheetData_1.push(rowData);
                });
            }
            // Create worksheet
            var worksheet = XLSX.utils.aoa_to_sheet(worksheetData_1);
            // Create workbook
            var workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
            // Generate filename
            var filename = props.label ? "".concat(props.label.replace(/\s+/g, '_'), ".xlsx") : 'download.xlsx';
            // Download file
            XLSX.writeFile(workbook, filename);
        }
        catch (error) {
            console.error('ACButton: Error generating Excel file:', error);
        }
    };
    var handleClick = function (e) {
        (0, ripple_1.createRipple)(e);
        e.stopPropagation();
        // Check if this is a preview download button
        if (props.previewDownload) {
            handleDownloadExcel();
            return;
        }
        // Otherwise call the regular onClick handler
        props.onClick && props.onClick(e);
    };
    var element = ((0, jsx_runtime_1.jsx)("button", { disabled: disabled, id: (props.id || ''), name: props.name || '', className: "ripple-effect apx-ui_btn ".concat((props === null || props === void 0 ? void 0 : props.variant) || '', " ").concat((props === null || props === void 0 ? void 0 : props.color) || '', " ").concat((props === null || props === void 0 ? void 0 : props.size) || '', " ").concat(props.className), onClick: handleClick, style: {
            position: 'relative',
            overflow: 'hidden',
            cursor: props.disabled ? 'no-drop' : 'pointer',
        }, children: (props === null || props === void 0 ? void 0 : props.iconPosition) === 'right' ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [props.label, (props === null || props === void 0 ? void 0 : props.iconClassName) ? ((0, jsx_runtime_1.jsx)("i", { className: "aci ".concat((props === null || props === void 0 ? void 0 : props.iconClassName) || '') })) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}))] })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(props === null || props === void 0 ? void 0 : props.iconClassName) ? ((0, jsx_runtime_1.jsx)("i", { className: "aci ".concat((props === null || props === void 0 ? void 0 : props.iconClassName) || '') })) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {})), props.label] })) }));
    return ((_a = props === null || props === void 0 ? void 0 : props.tooltip) === null || _a === void 0 ? void 0 : _a.title) ? ((0, jsx_runtime_1.jsx)(antd_1.Tooltip, { placement: (_b = props === null || props === void 0 ? void 0 : props.tooltip) === null || _b === void 0 ? void 0 : _b.placement, title: (_c = props === null || props === void 0 ? void 0 : props.tooltip) === null || _c === void 0 ? void 0 : _c.title, children: element })) : (element);
};
exports.ACButton = ACButton;
